import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '@/App';

const DivineAttractions = () => {
  const { language } = useContext(LanguageContext);

  const content = {
    en: {
      title: 'Divine Attractions',
      subtitle: 'Explore the sacred temples and spiritual destinations',
      readMore: 'Read More',
    },
    hi: {
      title: 'दिव्य आकर्षण',
      subtitle: 'पवित्र मंदिरों और आध्यात्मिक स्थलों का अन्वेषण करें',
      readMore: 'और पढ़ें',
    },
  };

  const temples = [
    {
      id: 'jay-taleti',
      name: 'Sri Jay Taleti',
      nameHi: 'श्री जय तलेटी',
      img: 'https://static.wixstatic.com/media/4365ca_1258e0b08f274c79a07b3f2843068e73~mv2.png',
      desc: 'A sacred pilgrimage site with profound spiritual significance',
      descHi: 'गहरे आध्यात्मिक महत्व के साथ एक पवित्र तीर्थ स्थल',
    },
    {
      id: 'girnar-tunk',
      name: 'Sri Girnar Tunk',
      nameHi: 'श्री गिरनार टूंक',
      img: 'https://static.wixstatic.com/media/4365ca_f45e65c17f3047e891a809c561130ace~mv2.png',
      desc: 'An ancient temple representing the glory of Girnar',
      descHi: 'गिरनार की महिमा का प्रतिनिधित्व करने वाला एक प्राचीन मंदिर',
    },
    {
      id: 'varshitap',
      name: 'Sri Varshitap Mandir',
      nameHi: 'श्री वर्षितप मंदिर',
      img: 'https://static.wixstatic.com/media/4365ca_cbaff8dc125048b6b7d8cd248d5cba92~mv2.png',
      desc: 'Dedicated to Varshitap, a symbol of devotion and penance',
      descHi: 'वर्षितप को समर्पित, भक्ति और तपस्या का प्रतीक',
    },
    {
      id: 'adinath',
      name: 'Sri Adinath Bhagwan Main Mandir',
      nameHi: 'श्री आदिनाथ भगवान मुख्य मंदिर',
      img: 'https://static.wixstatic.com/media/4365ca_bb83f89730b8417bb60bcea35f53f61e~mv2.png',
      desc: 'The main temple dedicated to Lord Adinath, the first Tirthankara',
      descHi: 'पहले तीर्थंकर भगवान आदिनाथ को समर्पित मुख्य मंदिर',
    },
    {
      id: 'ghetipag',
      name: 'Sri Ghetipag Mandir',
      nameHi: 'श्री घेटीपाग मंदिर',
      img: 'https://static.wixstatic.com/media/4365ca_16fd2e4343254440b2ad87cb161cc158~mv2.png',
      desc: 'A revered temple with unique architectural beauty',
      descHi: 'अद्वितीय वास्तुकला सुंदरता के साथ एक पूजनीय मंदिर',
    },
    {
      id: 'labhdhi',
      name: 'Sri Labhdhi Dadawadi - Dev Devi Mandir',
      nameHi: 'श्री लाभधि दाडावाडी - देव देवी मंदिर',
      img: 'https://static.wixstatic.com/media/4365ca_76c89b072465419b9ff41f8dcef34acb~mv2.png',
      desc: 'Temple dedicated to Dev and Devi deities',
      descHi: 'देव और देवी देवताओं को समर्पित मंदिर',
    },
    {
      id: 'motisa-tunk',
      name: 'Sri Motisa Tunk',
      nameHi: 'श्री मोटिसा टूंक',
      img: 'https://static.wixstatic.com/media/4365ca_600c1e43f90e4cf2815079a2c8eb3a49~mv2.png',
      desc: 'A spiritual landmark in the Teerth Dham',
      descHi: 'तीर्थ धाम में एक आध्यात्मिक स्थलचिह्न',
    },
    {
      id: 'upcoming',
      name: 'Other Upcoming Projects',
      nameHi: 'अन्य आगामी परियोजनाएं',
      img: 'https://static.wixstatic.com/media/4365ca_594cdafb37794153a6b5f1a82fe059de~mv2.png',
      desc: 'Exciting new spiritual developments coming soon',
      descHi: 'जल्द ही आने वाले रोमांचक नए आध्यात्मिक विकास',
    },
  ];

  const t = content[language];

  return (
    <div className="animate-fade-in">
      {/* Hero */}
      <section className="hero-section py-20 px-4" data-testid="attractions-hero">
        <div className="container mx-auto max-w-5xl text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold gradient-text mb-6" data-testid="attractions-title">
            {t.title}
          </h1>
          <p className="text-base md:text-lg text-amber-800" data-testid="attractions-subtitle">{t.subtitle}</p>
        </div>
      </section>

      {/* Temples Grid */}
      <section className="py-16 px-4 bg-white">
        <div className="container mx-auto max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {temples.map((temple) => (
              <Link key={temple.id} to={`/temple/${temple.id}`} data-testid={`attraction-card-${temple.id}`}>
                <div className="temple-card bg-white rounded-xl shadow-lg overflow-hidden h-full">
                  <div className="h-64 overflow-hidden">
                    <img
                      src={temple.img}
                      alt={language === 'en' ? temple.name : temple.nameHi}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-amber-900 mb-2">
                      {language === 'en' ? temple.name : temple.nameHi}
                    </h3>
                    <p className="text-sm text-amber-700 mb-4">
                      {language === 'en' ? temple.desc : temple.descHi}
                    </p>
                    <span className="text-amber-600 font-semibold text-sm hover:text-amber-700">
                      {t.readMore} →
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DivineAttractions;